import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils/get-action-types";
import {
  FETCH_BOOKINGS,
  UPDATE_BOOKING_CANCELED,
  UPDATE_BOOKING_CHECKED,
  UPDATE_BOOKING_VISITED,
} from "../constants/bookings";
import { ERROR, INIT, LOADING, OK } from "../constants";
import { CREATE_BOOKING } from "../constants/create-booking";
import { Action, BookingsState } from "../models/bookings";
import { CreateBookingAction } from "../models/create-booking";
import { Booking } from "../types";

const initialState: BookingsState = {
  status: INIT,
  error: {},
  data: {
    count: null,
    currentPage: null,
    pageCount: null,
    data: [],
    statuses: {
      acceptedBookingsCount: 0,
      pendingBookingsCount: 0,
      unknownBookingsCount: 0,
      unvisitedBookingsCount: 0,
      visitedBookingsCount: 0,
    },
  },
};

function data(state: BookingsState = initialState, action: Action | CreateBookingAction): BookingsState {
  switch (action.type) {
    case getRequestActionType(FETCH_BOOKINGS):
      return {
        ...state,
        status: LOADING,
        error: {},
      };
    case getSuccessActionType(FETCH_BOOKINGS):
      return {
        ...state,
        status: OK,
        error: {},
        data: action.payload,
      };
    case getFailureActionType(FETCH_BOOKINGS):
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    case getRequestActionType(UPDATE_BOOKING_CHECKED):
      return {
        ...state,
        status: LOADING,
        error: {},
      };
    case getSuccessActionType(UPDATE_BOOKING_CHECKED):
      var index = state.data.data.findIndex((x: Booking) => x.id == action.data.bookingId);
      var newBooking = Object.assign({}, state.data.data[index]);
      newBooking.checked = action.payload.checked;
      newBooking.meetingUrl = action.payload.meetingUrl;
      state.data.data[index] = newBooking;

      return {
        ...state,
        status: OK,
        error: {},
        data: { ...state.data },
      };
    case getFailureActionType(UPDATE_BOOKING_CHECKED):
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    case getRequestActionType(UPDATE_BOOKING_CANCELED):
      return {
        ...state,
        status: LOADING,
        error: {},
      };
    case getSuccessActionType(UPDATE_BOOKING_CANCELED):
      index = state.data.data.findIndex((x: Booking) => x.id == action.data.bookingId);
      newBooking = Object.assign({}, state.data.data[index]);
      newBooking.canceled = action.payload.canceled;
      state.data.data[index] = newBooking;

      return {
        ...state,
        status: OK,
        error: {},
        data: { ...state.data },
      };
    case getFailureActionType(UPDATE_BOOKING_CANCELED):
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    case getRequestActionType(UPDATE_BOOKING_VISITED):
      return {
        ...state,
        status: LOADING,
        error: {},
      };
    case getSuccessActionType(UPDATE_BOOKING_VISITED):
      index = state.data.data.findIndex((x: Booking) => x.id == action.data.bookingId);
      newBooking = Object.assign({}, state.data.data[index]);
      newBooking.visited = action.payload.visited;
      state.data.data[index] = newBooking;

      return {
        ...state,
        status: OK,
        error: {},
        data: { ...state.data },
      };
    case getFailureActionType(UPDATE_BOOKING_VISITED):
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    case getSuccessActionType(CREATE_BOOKING):
      state.data.data.push(action.payload);
      return {
        ...state,
        data: state.data,
      };
    default:
      return state;
  }
}

export default data;
